import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Warning } from 'icons/warning.svg';
import { STATEMENT_CONTENT_BLOCK } from 'constants/feature/statement-content-constants';
import ConfirmationModal from 'components/common/confirmation-modal';

const RotationalPagesWarningBanner = ({
  revision,
  urlParams,
  setIsBannerVisible,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { projectId, revisionId } = urlParams;

  const rotatedPages = useMemo(() => {
    if (revision?.errorMessage) {
      const errorMessage = revision.errorMessage;
      const pageNumbers = errorMessage.match(/\d+/g);
      return pageNumbers.join(', ') || '';
    }
    return '';
  }, [revision?.errorMessage]);

  const setFlagInLocalStorage = () => {
    const LSkey = 'ROTATIONAL_PAGES_WARNING_BANNER_VISIBILITY_DETAILS';
    const visibilityDetails = localStorage.getItem(LSkey);
    const parsedVisibilityDetails = visibilityDetails
      ? JSON.parse(visibilityDetails)
      : {};
    const flagKey = `${parseInt(projectId)}-${revisionId}`;
    parsedVisibilityDetails[flagKey] = false;
    localStorage.setItem(LSkey, JSON.stringify(parsedVisibilityDetails));
  };

  const onViewDetailsClick = () => {
    setIsModalOpen(true);
  };

  const onConfirmClick = () => {
    // Logic to handle confirmation, e.g., setting a flag to not show the banner again
    setFlagInLocalStorage(revisionId, projectId);
    setIsModalOpen(false);
    setIsBannerVisible(revision, urlParams);
  };

  return (
    <>
      <div
        className={classnames(
          `${STATEMENT_CONTENT_BLOCK}__center-panel-banner`,
        )}
      >
        <div>
          <Warning
            width={'20px'}
            height={'20px'}
            className={`${STATEMENT_CONTENT_BLOCK}__center-panel-banner-icon`}
          />
        </div>
        <div>
          <FormattedMessage
            id={'rotational.pages.found.banner.message.text'}
            values={{
              viewDetailsLink: (
                <span
                  className={`${STATEMENT_CONTENT_BLOCK}__rotational-page-warning-details-link`}
                  onClick={onViewDetailsClick}
                >
                  <FormattedMessage
                    id={'rotational.pages.found.banner.link-text'}
                  />
                </span>
              ),
            }}
          />
        </div>
      </div>
      {isModalOpen && (
        <ConfirmationModal
          title={'rotational.pages.found.banner.modal.title'}
          textId={'rotational.pages.found.banner.modal.text'}
          textValues={{ pageNumbers: rotatedPages }}
          onClose={() => setIsModalOpen(false)}
          onConfirm={onConfirmClick}
          primaryButtonText={
            'rotational.pages.found.banner.modal.primary.button.text'
          }
          secondaryButtonText={
            'rotational.pages.found.banner.modal.secondary.button.text'
          }
        />
      )}
    </>
  );
};

export default RotationalPagesWarningBanner;

RotationalPagesWarningBanner.propTypes = {
  //Revision data to determine the error code
  revision: PropTypes.object.isRequired,
  //URL parameters to determine the project and revision IDs to create unique keys to set in LS
  urlParams: PropTypes.object.isRequired,
  //Function to set the visibility of the banner
  setIsBannerVisible: PropTypes.func.isRequired,
};
